module.exports = __webpack_public_path__ + "img/question-mark.d858dafc.svg";